import { Injectable } from '@angular/core';
import ApiResponse from '../../models/common/api-response.model';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { PlayPeriod } from '../../models/play-period.model';
import { BehaviorSubject, Observable } from 'rxjs';
import ApiPagedResponse from '../../models/common/api-paged-response.model';
import Ticket from '../../models/ticket.model';
import ErrorResponse from '../../models/common/error-response.model';
import { AuthService } from '../authentication/auth.service';
import Purchase from '../../models/purchase.model';

@Injectable({
  providedIn: 'root',
})

export class TicketService {
  private baseUrl: string = environment.BASE_URL;
  playPeriod$: BehaviorSubject<PlayPeriod | null> = new BehaviorSubject<PlayPeriod | null>(null)

  constructor(private httpClient: HttpClient, private authService: AuthService) { }

  getPlayPeriod(): Observable<ApiResponse<PlayPeriod>> {
    return this.httpClient.get<ApiResponse<PlayPeriod>>(
      `${this.baseUrl}/api/tickets/play-period`,
      {
        headers: new HttpHeaders({
          Authorization: `Bearer ${this.authService.getAuthenticationToken()}`
        })
      }
    )
  }

  getTickets(page: number, pageSize: number, ticketNumber?: string): Observable<ApiPagedResponse<Ticket[]>> {
    return this.httpClient.get<ApiPagedResponse<Ticket[]>>(
      `${this.baseUrl}/api/tickets/search?page=${page}&pageSize=${pageSize}${ticketNumber ? `&number=${ticketNumber}` : ''}`
    )
  }

  postTicketByPaypal(purchasedTicket: string, votedTicket: string): Observable<ApiResponse<Purchase | ErrorResponse>> {
    return this.httpClient.post<ApiResponse<Purchase | ErrorResponse>>(
      `${this.baseUrl}/api/tickets/paypal`, {
      purchasedTicket: purchasedTicket,
      votedTicket: votedTicket
    }, {
      headers: new HttpHeaders({
        Authorization: `Bearer ${this.authService.getAuthenticationToken()}`
      })
    })
  }

  postTicketByCard(purchasedTicket: string, votedTicket: string): Observable<ApiResponse<Purchase | ErrorResponse>> {
    return this.httpClient.post<ApiResponse<Purchase | ErrorResponse>>(
      `${this.baseUrl}/api/tickets/card`, {
      purchasedTicket: purchasedTicket,
      votedTicket: votedTicket
    }, {
      headers: new HttpHeaders({
        Authorization: `Bearer ${this.authService.getAuthenticationToken()}`
      })
    })
  }

  postTicketByCrypto(purchasedTicket: string, votedTicket: string, transactionHash: string): Observable<ApiResponse<null | ErrorResponse>> {
    return this.httpClient.post<ApiResponse<null | ErrorResponse>>(
      `${this.baseUrl}/api/tickets/crypto`, {
      purchasedTicket: purchasedTicket,
      votedTicket: votedTicket,
      transactionHash: transactionHash
    }, {
      headers: new HttpHeaders({
        Authorization: `Bearer ${this.authService.getAuthenticationToken()}`
      })
    })
  }

  getTicketsArchivedOfUser(page: number, pageSize: number): Observable<ApiPagedResponse<Ticket[]>> {
    return this.httpClient.get<ApiPagedResponse<Ticket[]>>(`${this.baseUrl}/api/tickets/archived/user?page=${page}&pageSize=${pageSize}`,
      {
        headers: new HttpHeaders({
          Authorization: `Bearer ${this.authService.getAuthenticationToken()}`
        }
        )
      }
    )
  }

  sendSupportRequest(name: string, emailAddress: string, message: string): Observable<ApiResponse<null | ErrorResponse>> {
    return this.httpClient.post<ApiResponse<null | ErrorResponse>>(
      `${this.baseUrl}/api/utils/send-support-email`, {
      name: name,
      emailAddress: emailAddress,
      message: message
    }
    )
  }
}
